import Vue from "vue";
import * as api from "@lab/api/dashboards.api";
import { Dashboard } from "@lab/types/dashboard";

const state = {
	byID: [],
	clone: null,
	fetching: false,
	errorMessage: null,
	lastFetched: null // Timestamp
};

const getters = {
	clone: (state) => state.clone,
	list: (state): Dashboard[] =>
		(state.byID ? Object.values(state.byID) : []) as Dashboard[],
	fetching: (state): boolean => state.fetching as boolean
};

const actions = {
	async fetch({ commit }) {
		commit("LOAD_START");
		const dashboards = await api.fetchAll();
		commit("LOAD_LIST_SUCCESS", dashboards);
		commit("LOAD_FINISH");
	},
	clone({ commit }, dashboard) {
		let clone = null;
		// In case we are clearing the clone we need to check if it has been set to use it
		if (dashboard) {
			// We're going to update name so we can see its been duplicated
			const name = `${dashboard.name} (copy)`;
			// we don;t need all the object to cloned so just grabbing what is required
			clone = {
				name,
				type: dashboard.type,
				layout: dashboard.layout,
				LayoutJSON: dashboard.LayoutJSON
			};
		}

		commit("SET_CLONE", clone);
	}
};

const mutations = {
	LOAD_LIST_SUCCESS(state: any, dashboards: Dashboard[]) {
		const byID = dashboards.reduce((acc, val) => {
			acc[val.id] = val;
			return acc;
		}, {});
		Vue.set(state, "byID", byID);
		state.lastFetched = Date.now();
		state.isFetching = false;
	},
	LOAD_START(state) {
		state.isFetching = true;
	},
	LOAD_FINISH(state) {
		state.isFetching = false;
	},
	SET_CLONE(state, dashboard: Dashboard) {
		state.clone = dashboard;
	}
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
}; // eslint-disable-line
